/* eslint-disable @typescript-eslint/no-explicit-any */
import { lazy, Suspense } from 'react';
import { EditableComponent, ResponsiveGrid } from '@adobe/aem-react-editable-components';
import { AEMReactCompMap } from '@marriott/mi-ui-library';

import { buildItemProps, getOffersComponent } from '../../lib/helper';

export const MathDMEContainerReactWrapper = (props: any) => {
  const { isAuthorMode, model } = props;
  const isMathOffer: boolean = props?.offersData?.responseObject?.edges?.[0]?.merchandisingNode?.isMathOffer;
  const mapper = AEMReactCompMap(props?.allowedComponents);

  const authorGrid = () => {
    return (
      <ResponsiveGrid
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        pagePath={model?.pagePath}
        itemPath={model?.itemPath}
        columnCount="12"
        gridClassNames={''}
        config={{
          isEmpty: () => true,
          resourceType: 'mi-aem-common-spa/components/container',
        }}
        isInEditor={true}
      />
    );
  };

  const publishComponentWrapper = (cardName: string, items: any): JSX.Element | null => {
    const item = items[cardName];
    if (!item) return null;

    const itemType = item[':type']?.split('/').pop();
    if (!mapper[itemType]) return null;

    const Component = lazy(() => getOffersComponent(mapper[itemType], itemType, item[':type']));
    const itemProps = buildItemProps(item, itemType, mapper[itemType], props);

    return (
      <Suspense fallback={<></>} key={cardName}>
        <Component {...itemProps} />
      </Suspense>
    );
  };

  return (
    <div>
      {isAuthorMode && authorGrid()}
      {!isAuthorMode &&
        isMathOffer &&
        model?.[':itemsOrder']?.length > 0 &&
        model[':itemsOrder'].map((cardName: string) => publishComponentWrapper(cardName, model[':items']))}
    </div>
  );
};

export const MathDMEContainerWrapperConfig = {
  emptyLabel: 'MathDMEContainer',
  isEmpty: () => true,
  resourceType: `mi-aem-offers-spa/components/mathdmecontainer`,
};

// Use named rather than default exports.
export const MathDMEContainer = (props: any) => (
  <EditableComponent {...props} config={MathDMEContainerWrapperConfig}>
    <div
      className={`${props?.model?.styleclass || ''}`}
      data-testid="mathdmecontainer"
      data-component-name="o-offers-mathdmecontainer"
    >
      <MathDMEContainerReactWrapper {...props} />
    </div>
  </EditableComponent>
);
